import { VacancyCardProps } from "storyblok/components";
import { useState } from "react";
import Link from "next/link";
import parse from "html-react-parser";

import { ARROW_RIGHT, CLOCK, Icon, MAP_PIN, USER } from "components/ui";
import { Loader } from "components/shared/loader/Loader";

import {
    Arrow,
    Bottom,
    Category,
    Description,
    Info,
    InfoBlock,
    InfoContent,
    InfoIcon,
    LoaderWrapper,
    StyledAnchor,
    Title,
    Wrapper
} from "./VacancyCard.styled";

import { getEducationCode } from "helpers/hooks/getEducationCode";

export function VacancyCard({
    className,
    title,
    description,
    href,
    category,
    hours,
    education,
    region,
    overview,
    salary
}: VacancyCardProps): JSX.Element {
    const [loading, setLoading] = useState(false);

    const educationCode = getEducationCode(education);
    return (
        <Link legacyBehavior href={`${href}`} passHref prefetch={false}>
            <StyledAnchor href="#" onClick={() => setLoading(true)}>
                <Wrapper className={className} overview={overview}>
                    {loading && (
                        <LoaderWrapper>
                            <Loader />
                        </LoaderWrapper>
                    )}
                    {title && <Title title={title}>{title}</Title>}

                    {description && (
                        <Description>{parse(description + "...")}</Description>
                    )}

                    <Bottom>
                        <Info>
                            {category && <Category>{category}</Category>}
                            {hours && (
                                <InfoBlock>
                                    <InfoIcon>
                                        <Icon
                                            icon={CLOCK}
                                            size={20}
                                            color="var(--color-primary)"
                                        />
                                    </InfoIcon>
                                    <InfoContent>{hours}</InfoContent>
                                </InfoBlock>
                            )}

                            {!!educationCode && (
                                <InfoBlock title={educationCode}>
                                    <InfoIcon>
                                        <Icon
                                            icon={USER}
                                            size={20}
                                            color="var(--color-primary)"
                                        />
                                    </InfoIcon>
                                    <InfoContent>{educationCode}</InfoContent>
                                </InfoBlock>
                            )}

                            {region && (
                                <InfoBlock>
                                    <InfoIcon>
                                        <Icon
                                            icon={MAP_PIN}
                                            size={20}
                                            color="var(--color-primary)"
                                        />
                                    </InfoIcon>
                                    <InfoContent>{region}</InfoContent>
                                </InfoBlock>
                            )}

                            {salary && (
                                <InfoBlock>
                                    <span>€</span>
                                    <InfoContent>{salary}</InfoContent>
                                </InfoBlock>
                            )}
                        </Info>
                        <Arrow>
                            <Icon
                                icon={ARROW_RIGHT}
                                size={24}
                                color="var(--color-primary)"
                            />
                        </Arrow>
                    </Bottom>
                </Wrapper>
            </StyledAnchor>
        </Link>
    );
}
